import { Component, OnInit } from '@angular/core';
import { Firestore, collection, query, where, collectionData } from '@angular/fire/firestore';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  // Variables de environment
  isBeta = environment.beta;
  isProduction = environment.production;
  version = environment.version;

  // Usuario autenticado actual
  user: any = {};
  // Total de reliefs del usuario
  totalReliefs = 0;
  // Racha de días consecutivos escribiendo reliefs
  writingStreak = 0;
  // Sentimiento más frecuente del último mes
  recurrentFeeling = '';
  // Conteo de sentimientos del último mes (por tipo)
  feelingCount: { [key: string]: number } = {};
  wroteToday = false;

  constructor(
    private _authService: AuthService,
    private firestore: Firestore
  ) {}

  ngOnInit(): void {
    // Suscripción reactiva al estado de auth
    this._authService.user$.subscribe(user => {
      this.user = user;

      if (this.user?.uid) {
        const colRef = collection(this.firestore, 'reliefs');
        const q = query(colRef, where('userId', '==', this.user.uid));

        collectionData(q).subscribe((reliefs: any[]) => {
          // Total de reliefs
          this.totalReliefs = reliefs.length;
          // Calcula la racha de días escribiendo
          this.writingStreak = this.calculateStreak(reliefs);

          // Filtra reliefs del último mes
          const monthAgo = new Date();
          monthAgo.setMonth(monthAgo.getMonth() - 1);
          const monthReliefs = reliefs.filter(r => {
            const date = r.createdAt?.toDate?.() || r.createdAt;
            return new Date(date) >= monthAgo;
          });

          // Cuenta cuántos reliefs hay de cada sentimiento en el último mes
          this.feelingCount = {};
          monthReliefs.forEach(r => {
            this.feelingCount[r.feeling] = (this.feelingCount[r.feeling] || 0) + 1;
          });

          // Determina el sentimiento más frecuente del último mes
          this.recurrentFeeling = Object.entries(this.feelingCount)
            .sort((a, b) => b[1] - a[1])[0]?.[0] || 'Sin datos';
        });
      }
    });
  }

  /**
   * Calcula la racha de días consecutivos en los que el usuario ha escrito reliefs.
   * @param reliefs Array de reliefs del usuario
   * @returns Número de días consecutivos escribiendo
   */
  calculateStreak(reliefs: any[]): number {
    const days = new Set(
      reliefs
        .map(r => r.createdAt?.toDate?.() || r.createdAt)
        .filter(Boolean)
        .map((d: Date) => new Date(d).setHours(0, 0, 0, 0))
    );

    if (days.size === 0) {
      this.wroteToday = false;
      return 0;
    }

    const sortedDays = Array.from(days).sort((a, b) => b - a);

    // Fechas de hoy y ayer
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Día más reciente registrado
    const lastDay = sortedDays[0];

    // Si el último día NO es hoy NI ayer, racha 0
    if (lastDay !== today.getTime() && lastDay !== yesterday.getTime()) {
      this.wroteToday = false;
      return 0;
    }

    // Calcula la racha consecutiva desde el día más reciente hacia atrás
    let streak = 1;
    let prev = lastDay;
    for (let i = 1; i < sortedDays.length; i++) {
      if (prev - sortedDays[i] === 86400000) {
        streak++;
        prev = sortedDays[i];
      } else {
        break;
      }
    }

    // Si el último día es hoy, emoji 🔥; si es ayer, emoji 🪵
    this.wroteToday = lastDay === today.getTime();

    return streak;
  }
}
